<template>
  <PrintPage :pageNumber="pageNumber">
    <template v-slot:header>
      <slot>
        <PrintHeaderSSPSlim />
      </slot>
    </template>

    <!-- Anmerkungen zu Vorschäden -->
    <div class="content-box">
      <div class="content-box-header">
        <h3>{{ $t('existingDamageNotes') }}</h3>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('existingDamageNotes') }}</div>
        <div>{{ $t(project.enpalReport.existingDamageNotes) }}</div>
      </div>
    </div>

    <!-- Bilder Vorschäden -->
    <AttachmentsPrintGrid
      :attachments="project.damageAttachments"
      fieldName="damageAttachments"
      fieldDescription="damageAttachments"
      :maxImages="6"
    />
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderSSPSlim from '@/components/Print/PrintHeaderSSPSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';
import { range } from '@/helpers/math.js';

export default {
  name: 'MeasurementPrintPage1',
  components: {
    PrintPage,
    PrintHeaderSSPSlim,
    AttachmentsPrintGrid,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {},
  methods: { range },
};
</script>
